<div class="page-title-area">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container">
        <div class="page-title-text">
          <h2>FORMULAIRE DE CREATION D'ENTREPRISE</h2>
          <ul>
            <li><a routerLink="/">ACCUEIL</a></li>
            <li><i class="icofont-simple-right"></i></li>
            <li>FORMULAIRE DE CREATION D'ENTREPRISE</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="create-account-container pt-100 pb-170">
  <div class="container">
    <div class="form-card">
      <div class="card-header">
        <!-- Header Title Section -->
        
        
        <!-- Stepper Navigation -->
        <div class="stepper-wrapper">
          <p-steps [model]="items" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>
        </div>
      </div>

      <div class="card-body p-0">
        <form
          enctype="multipart/form-data"
          [formGroup]="form"
          (ngSubmit)="onSubmit()"
          class="registration-form"
        >
          <!-- Step 1: Informations Générales et Forme Juridique -->
          <div class="step-content" *ngIf="activeIndex === 0">
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-info-circle me-3"></i>
                  Informations Générales
                </h3>
                <p class="section-description">
                  Renseignez les informations de base de votre entreprise
                </p>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-building me-2"></i>
                    Nom de l'entreprise
                    <span class="required">*</span>
                  </label>
                  <input 
                    type="text" 
                    class="form-control" 
                    formControlName="name"
                    placeholder="Entrez le nom de votre entreprise"
                  />
                  <div class="error-message" *ngIf="form.get('name').touched && form.get('name').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-calendar me-2"></i>
                    Date de création
                    <span class="required">*</span>
                  </label>
                  <input
                    formControlName="year_of_registration"
                    type="date"
                    class="form-control"
                  />
                  <div class="error-message" *ngIf="form.get('year_of_registration').touched && form.get('year_of_registration').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>
                
              </div>

              <div class="form-grid">
                 <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-email me-2"></i>
                    Email de l'entreprise
                    <span class="required">*</span>
                  </label>
                  <input
                    type="email"
                    formControlName="email"
                    class="form-control"
                    placeholder="contact@entreprise.com"
                  />
                  <div class="error-message" *ngIf="form.get('email').touched && form.get('email').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-phone me-2"></i>
                    Téléphone de l'entreprise
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    formControlName="phone_number"
                    class="form-control"
                    mask="000 00 00 00"
                    placeholder="000 00 00 00"
                  />
                  <div class="error-message" *ngIf="form.get('phone_number').touched && form.get('phone_number').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

              </div>
            </div>

            <!-- Formes Juridiques -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-file-text me-3"></i>
                  Forme Juridique
                </h3>
                <p class="section-description">
                  Sélectionnez la forme juridique qui correspond à votre entreprise
                </p>
              </div>

              <div class="legal-forms-grid">
                <div class="legal-form-item" *ngFor="let companyType of companyTypes">
                  <label class="legal-form-label">
                    <input 
                      type="radio" 
                      class="legal-form-input"
                      formControlName="type"
                      name="type" 
                      [id]="'type-' + companyType.id"
                      [value]="companyType.id"
                    />
                    <div class="legal-form-content">
                      <div class="legal-form-text">
                        <span class="legal-form-name">{{ companyType.name }}</span>
                        <span class="legal-form-hint">Cliquez pour sélectionner</span>
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <div class="error-message" *ngIf="form.get('type').touched && form.get('type').hasError('required')">
                <i class="icofont-warning-alt"></i>
                Veuillez sélectionner une forme juridique
              </div>
            </div>

            <!-- Localisation -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-location-pin me-3"></i>
                  Localisation
                </h3>
                <p class="section-description">
                  Adresse et localisation de votre entreprise
                </p>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-map me-2"></i>
                    Région
                    <span class="required">*</span>
                  </label>
                  <select
                    formControlName="region"
                    class="form-select"
                    (change)="onRegionsChanged($event)"
                  >
                    <option value="null">Sélectionnez une région</option>
                    <option
                      *ngFor="let region of regionService.value"
                      [value]="region.id"
                    >
                      {{ region.name }}
                    </option>
                  </select>
                  <div class="error-message" *ngIf="form.get('region').touched && form.get('region').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-building me-2"></i>
                    Préfecture
                  </label>
                  <select
                    class="form-select"
                    formControlName="prefecture"
                    (change)="onPrefecturesChanged($event)"
                  >
                    <option value="null">Sélectionnez une préfecture</option>
                    <option
                      *ngFor="let prefecture of prefectures"
                      [value]="prefecture.id"
                    >
                      {{ prefecture.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-home me-2"></i>
                    Commune
                  </label>
                  <select formControlName="commune" class="form-select">
                    <option value="null">Sélectionnez une commune</option>
                    <option *ngFor="let commune of communes" [value]="commune.id">
                      {{ commune.name }}
                    </option>
                  </select>
                </div>

                <div class="form-group full-width">
                  <label class="form-label">
                    <i class="icofont-location-pin me-2"></i>
                    Adresse principale
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="address"
                    placeholder="Adresse complète de votre entreprise"
                  />
                  <div class="error-message" *ngIf="form.get('address').touched && form.get('address').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 2: Description et Domaines d'activité -->
          <div class="step-content" *ngIf="activeIndex === 1">
            <!-- Description de l'entreprise -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-document me-3"></i>
                  Description de l'entreprise
                </h3>
                <p class="section-description">
                  Présentez votre entreprise et ses activités
                </p>
              </div>

              <div class="form-group">
                <label class="form-label">
                  <i class="icofont-edit me-2"></i>
                  Description
                  <span class="required">*</span>
                </label>
                <div class="editor-container">
                  <ngx-editor-menu [editor]="editor"></ngx-editor-menu>
                  <ngx-editor
                    formControlName="description"
                    [editor]="editor"
                    [(ngModel)]="html"
                    [placeholder]="'Décrivez votre entreprise, ses activités, ses valeurs et ses objectifs...'"
                  ></ngx-editor>
                </div>
                <div class="error-message" *ngIf="form.get('description').touched && form.get('description').hasError('required')">
                  <i class="icofont-warning-alt"></i>
                  Ce champ est obligatoire
                </div>
              </div>
            </div>

            <!-- Domaines d'activité -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-tags me-3"></i>
                  Domaines d'activité
                </h3>
                <p class="section-description">
                  Sélectionnez un ou plusieurs secteurs d'activité correspondant à votre entreprise
                </p>
              </div>

              <div *ngIf="filteredCategories.length > 0; else noResults" class="categories-grid">
                <div class="category-item" *ngFor="let category of filteredCategories; let i = index">
                  <label class="category-label">
                    <input
                      type="checkbox"
                      class="category-checkbox"
                      [value]="category.id"
                      (change)="onCheckboxChange($event)"
                      [checked]="isCategorySelected(category.id)"
                    />
                    <div class="category-content">
                      <div class="category-text">
                        <span class="category-name">{{ category.name }}</span>
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              <ng-template #noResults>
                <div class="no-results">
                  <p>Aucun résultat trouvé pour "{{ search }}"</p>
                  <button class="btn-clear-search" (click)="search = ''">
                    Effacer la recherche
                  </button>
                </div>
              </ng-template>

              <div class="selected-categories" *ngIf="form.get('categories').value?.length > 0">
                <div class="selected-count">
                  {{ form.get('categories').value?.length }} secteur(s) sélectionné(s)
                </div>
                <div class="selected-tags">
                  <span class="tag" *ngFor="let catId of form.get('categories').value">
                    {{ getCategoryName(catId) }}
                  </span>
                </div>
              </div>

              <div class="error-message" *ngIf="form.get('categories').touched && form.get('categories').hasError('required')">
                Veuillez sélectionner au moins un domaine d'activité
              </div>
            </div>
          </div>

          <!-- Step 3: Informations Financières et Contact -->
          <div class="step-content" *ngIf="activeIndex === 2">
            <!-- Informations Financières -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-chart-line me-3"></i>
                  Informations Financières
                </h3>
                <p class="section-description">
                  Renseignez les données financières de votre dernier exercice
                </p>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-calendar me-2"></i>
                    Dernier exercice comptable
                    <span class="required">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="date_of_last_exercise"
                  />
                  <div class="error-message" *ngIf="form.get('date_of_last_exercise').touched && form.get('date_of_last_exercise').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-users me-2"></i>
                    Effectif du dernier exercice
                    <span class="required">*</span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    formControlName="effective_of_exercise"
                    placeholder="Nombre d'employés"
                  />
                  <div class="error-message" *ngIf="form.get('effective_of_exercise').touched && form.get('effective_of_exercise').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-money me-2"></i>
                    Chiffre d'affaires du dernier exercice
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="chiffre_of_exercise"
                    placeholder="Saisissez le chiffre d'affaires sans espace, ni virgule"
                  />
                  <div class="error-message" *ngIf="form.get('chiffre_of_exercise').touched && form.get('chiffre_of_exercise').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>
              </div>
            </div>

            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-calendar me-3"></i>
                  Informations du Quitus social
                </h3>
                <p class="section-description">
                  Renseignez les informations du quitus social
                </p>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-calendar me-2"></i>
                    Date d'expiration du NIFP
                    <span class="required">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="nifp_expiration_date"
                  />
                  <div class="error-message" *ngIf="form.get('nifp_expiration_date').touched && form.get('nifp_expiration_date').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-calendar me-2"></i>
                    Date d'expiration du quitus social
                    <span class="required">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="quitus_social_expiration_date"
                  />
                  <div class="error-message" *ngIf="form.get('quitus_social_expiration_date').touched && form.get('quitus_social_expiration_date').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

              </div>
            </div>

            <!-- Informations de Contact -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-phone me-3"></i>
                  Informations de Contact
                </h3>
                <p class="section-description">
                  Vos coordonnées pour nous contacter
                </p>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-user me-2"></i>
                    Nom de la personne à contacter
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="customer_last_name"
                    placeholder="Entrez le nom de la personne à contacter"
                  />
                  <div class="error-message" *ngIf="form.get('customer_last_name').touched && form.get('customer_last_name').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
              </div>
              <div class="form-group">
                <label class="form-label">
                  <i class="icofont-user me-2"></i>
                  Prénom de la personne à contacter
                  <span class="required">*</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="customer_first_name"
                  placeholder="Entrez le prénom de la personne à contacter"
                />
                <div class="error-message" *ngIf="form.get('customer_first_name').touched && form.get('customer_first_name').hasError('required')">
                  <i class="icofont-warning-alt"></i>
                  Ce champ est obligatoire
                </div>
              </div>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-phone me-2"></i>
                    Téléphone de la personne à contacter
                    <span class="required">*</span>
                  </label>
                  <input
                    type="tel"
                    mask="000 00 00 00"
                    class="form-control"
                    formControlName="customer_phone_number"
                    placeholder="000 00 00 00"
                  />
                  <div class="error-message" *ngIf="form.get('customer_phone_number').touched && form.get('customer_phone_number').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-envelope me-2"></i>
                    Email de la personne à contacter
                    <span class="required">*</span>
                  </label>
                  <input
                    type="email"
                    class="form-control"
                    formControlName="customer_email"
                    placeholder="exemple@email.com"
                  />
                  <div class="error-message" *ngIf="form.get('customer_email').touched && form.get('customer_email').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Step 4: Informations Complémentaires et Confirmation -->
          <div class="step-content" *ngIf="activeIndex === 3">
            <!-- Informations Complémentaires -->
            <div class="form-section">
              <div class="section-header">
                <h3 class="section-title">
                  <i class="icofont-info-circle me-3"></i>
                  Informations Complémentaires
                </h3>
                <p class="section-description">
                  Informations additionnelles sur votre entreprise
                </p>
              </div>

              <div class="form-grid">
                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-user me-2"></i>
                    Nom complet du dirigeant
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="leader_full_name"
                    placeholder="Nom et prénoms du dirigeant"
                  />
                  <div class="error-message" *ngIf="form.get('leader_full_name').touched && form.get('leader_full_name').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label">
                    <i class="icofont-badge me-2"></i>
                    Qualité du dirigeant
                    <span class="required">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="leader_quality"
                    placeholder="Fonction du dirigeant"
                  />
                  <div class="error-message" *ngIf="form.get('leader_quality').touched && form.get('leader_quality').hasError('required')">
                    <i class="icofont-warning-alt"></i>
                    Ce champ est obligatoire
                  </div>
                </div>
              </div>

              
            </div>

            <div class="form-section">
            <div class="section-header">
              <h3 class="section-title">
                <i class="icofont-settings me-3"></i>
                Caractéristiques de l'entreprise
              </h3>
              <p class="section-description">
                Informations sur la structure de votre entreprise
              </p>
            </div>

            <div class="characteristics-grid">
              <div class="characteristic-item">
                <label class="characteristic-label">
                  <i class="icofont-shield-check me-2"></i>
                  Activité réglementée
                  <span class="required">*</span>
                </label>
                <div class="select-button-container">
                  <p-selectButton
                    formControlName="reglemented_activity"
                    [options]="stateOptions"
                    optionLabel="label"
                    optionValue="value"
                  ></p-selectButton>
                </div>
                <div class="error-message" *ngIf="form.get('reglemented_activity').touched && form.get('reglemented_activity').hasError('required')">
                  <i class="icofont-warning-alt"></i>
                  Ce champ est obligatoire
                </div>
              </div>

              <div class="characteristic-item">
                <label class="characteristic-label">
                  <i class="icofont-users me-2"></i>
                  Actionnariat
                  <span class="required">*</span>
                </label>
                <div class="select-button-container">
                  <p-selectButton
                    formControlName="actionnariat"
                    [options]="stateOptions"
                    optionLabel="label"
                    optionValue="value"
                  ></p-selectButton>
                </div>
                <div class="error-message" *ngIf="form.get('actionnariat').touched && form.get('actionnariat').hasError('required')">
                  <i class="icofont-warning-alt"></i>
                  Ce champ est obligatoire
                </div>
              </div>

              <div class="characteristic-item">
                <label class="characteristic-label">
                  <i class="icofont-network me-2"></i>
                  Appartenance à un groupe
                  <span class="required">*</span>
                </label>
                <div class="select-button-container">
                  <p-selectButton
                    formControlName="group_joined"
                    [options]="stateOptions"
                    optionLabel="label"
                    optionValue="value"
                  ></p-selectButton>
                </div>
                <div class="error-message" *ngIf="form.get('group_joined').touched && form.get('group_joined').hasError('required')">
                  <i class="icofont-warning-alt"></i>
                  Ce champ est obligatoire
                </div>
              </div>

              <div class="characteristic-item">
                <label class="characteristic-label">
                  <i class="icofont-branch me-2"></i>
                  Filiales
                  <span class="required">*</span>
                </label>
                <div class="select-button-container">
                  <p-selectButton
                    formControlName="filiale"
                    [options]="stateOptions"
                    optionLabel="label"
                    optionValue="value"
                  ></p-selectButton>
                </div>
                <div class="error-message" *ngIf="form.get('filiale').touched && form.get('filiale').hasError('required')">
                  <i class="icofont-warning-alt"></i>
                  Ce champ est obligatoire
                </div>
              </div>
            </div>
          </div>

          </div>

          <!-- Navigation Buttons -->
          <div class="stepper-navigation">
            <button 
              type="button" 
              class="btn-stepper btn-stepper-prev" 
              (click)="prevStep()" 
              *ngIf="activeIndex > 0"
            >
              <i class="icofont-rounded-left me-2"></i>
              Étape précédente
            </button>
            
            <button 
              type="button" 
              class="btn-stepper btn-stepper-next" 
              (click)="nextStep()" 
              *ngIf="activeIndex < 3"
            >
              Étape suivante
              <i class="icofont-rounded-right ms-2"></i>
            </button>
            
            <button
              type="submit"
              class="btn-stepper btn-stepper-submit"
              [disabled]="loading"
              *ngIf="activeIndex === 3"
            >
              <span class="btn-content" *ngIf="!loading">
                <i class="icofont-check-circled me-2"></i>
                Créer mon entreprise
              </span>
              <span class="btn-loading" *ngIf="loading">
                <i class="icofont-spinner-alt-1 icofont-spin me-2"></i>
                Création en cours...
              </span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
